// @flow

import { Serializer, Deserializer } from 'jsonapi-serializer';
import apiServerUrl from '../config/env';
import { token } from '../config';

export default class Api {
  backendUrl: string;
  serializerType: string;
  serializerOptions: any;

  constructor(backendUrl: string = apiServerUrl) {
    this.backendUrl = backendUrl;
    this.serializerType = '';
    this.serializerOptions = {};
  }

  request = async (url: string, params: {} = {}) => new Promise<any>(async (resolve, reject): any => {
    const headers = {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
      'X-CSRF-TOKEN': token
    };

    try {
      const response = await fetch(`${this.backendUrl}/api/v3/${url}`, { headers, ...params });

      try {
        if (response.status === 204) return resolve({ data: {}, meta: {} });
        const json = await response.json();
        return response.ok ? resolve(json) : reject(json);
      } catch (error) {
        const { message } = error;
        return reject(new Error(`Received a non-JSON response, aborting. | ${message}`));
      }
    } catch (error) {
      const { message } = error;
      return reject(message);
    }
  })

  serialize = async (dataSet: {}) => new Promise(async (resolve, reject) => {
    try {
      const data = await new Serializer(this.serializerType, { ...this.serializerOptions, keyForAttribute: 'snake_case' }).serialize(dataSet);
      return resolve(data);
    } catch (error) {
      const { message } = error;
      return reject(new Error(`Serialize aborting. | ${message}`));
    }
  })

  deserialize = async (json: {}, options: {} = {}) => new Promise(async (resolve, reject) => {
    try {
      const data = await new Deserializer({ keyForAttribute: 'camelCase', typeAsAttribute: true, ...options }).deserialize(json);
      return resolve(data);
    } catch (error) {
      const { message } = error;
      return reject(new Error(`Deserialize aborting. | ${message}`));
    }
  })
}
